import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { FaBarcode, FaCreditCard, FaDollarSign, FaPix } from 'react-icons/fa6';

import FORMATTERS from 'helpers/formatters';
import { CustomCard, Value } from '_components/Settings/components/SettingsV2/styles';
import { Skeleton } from '_components/_core';

import { SummaryTable } from './styles';

const PAYMENT_METHOD_ICON = {
  BOLETO: <FaBarcode className="ml-2 mr-2" />,
  CREDIT_CARD: <FaCreditCard className="ml-2 mr-2" />,
  DEBIT_CARD: <FaCreditCard className="ml-2 mr-2" />,
  PIX: <FaPix className="ml-2 mr-2" />,
  UNDEFINED: <FaDollarSign className="ml-2 mr-2" />,
};

function ChargesPaymentMethodList({ data, isLoading }) {
  return (
    <CustomCard className="p-3 mb-3">
      <div className="w-100 flex-column d-flex justify-content-between align-items-start">
        <Value>Formas de pagamento</Value>
      </div>
      {isLoading ? <Skeleton className="mt-1 mb-2" /> : null}
      {!isLoading && data && !isEmpty(data.payment_method_summary) && (
        <SummaryTable className="mt-3 table table-hover">
          <thead>
            <tr>
              <th className="text-left">FORMA DE PAGAMENTO</th>
              <th className="text-right">QTDE</th>
              <th className="text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            {data.payment_method_summary
              .filter(item => item.quantity > 0)
              .map((item, index) => (
                <tr key={index}>
                  <td className="text-left">
                    <span className="d-flex align-items-center">
                      {PAYMENT_METHOD_ICON[item.payment_method_mnemonic]}
                      {item.payment_method}
                    </span>
                  </td>
                  <td className="text-right financial-value">{item.quantity}</td>
                  <td className="text-right financial-value">
                    <span className="mr-2">{FORMATTERS.NUMBER(item.amount)}</span>
                  </td>
                </tr>
              ))}
          </tbody>
        </SummaryTable>
      )}
    </CustomCard>
  );
}

ChargesPaymentMethodList.defaultProps = {
  data: null,
  isLoading: false,
};

ChargesPaymentMethodList.propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.bool,
};

export default ChargesPaymentMethodList;
